<div cdkDrag 
    cdkDragLockAxis="y" 
    class="doc-drag-box padding-smaller border-gray flex-row border-radius-small"
    [ngClass]="{
      'primary-background-A200-transparent':select
    }"
  >
    
  <div cdkDragHandle class="doc-drag-icon">
    <mat-icon>drag_indicator</mat-icon>
  </div>

  <form class="flex-1" [formGroup]="mainFormGroupSubject | async" >

    <mat-form-field class="tiny-form-field full-width" floatLabel="auto">
      <mat-label *ngIf="!input.value">{{ "ss-entities.process.title" | translate }}</mat-label>
      <input [ngClass]="{'light-bold':select}" #input matInput dataField="name" formControlName="name" />
      <mat-error *ngIf="showErrorSubject | async"></mat-error>
    </mat-form-field>
  </form>



  <button 
    mat-icon-button
    color="warn" 
    (click)="removeDocument()">
    <mat-icon>delete</mat-icon>
  </button>


  <!-- <div *cdkDragPlaceholder>

    <ss-document-item class="display-block" [select]="true" [pdfDocument]="pdfDocumentSubject | async" [idx]="idxSubject | async"></ss-document-item>
  </div> -->

    
</div>